import { render, staticRenderFns } from "./VDropdownDivider.vue?vue&type=template&id=5cc7eac9"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc7eac9')) {
      api.createRecord('5cc7eac9', component.options)
    } else {
      api.reload('5cc7eac9', component.options)
    }
    module.hot.accept("./VDropdownDivider.vue?vue&type=template&id=5cc7eac9", function () {
      api.rerender('5cc7eac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dropdown/VDropdownDivider.vue"
export default component.exports